import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { machineGroups, machineInGroups } from "api/myMachines";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const DemoPaper = styled(Paper)(({ theme }) => ({
  width: "100%",
  padding: theme.spacing(3),
  ...theme.typography.body2,
  textAlign: "left",
  backgroundColor: "#f9f9f9",
}));

function MachinesInGroups() {
  const { groupId } = useParams();
  const [groupList, setGroupList] = useState([]);
  const [machines, setMachines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const { data } = await machineGroups();
        setGroupList(data || []);
      } catch (err) {
        setError("Failed to load machine groups.");
      } finally {
        setLoading(false);
      }
    };
    fetchGroups();
  }, []);
  useEffect(() => {
    const fetchMachines = async () => {
      try {
        const { data } = await machineInGroups(groupId);
        setMachines(data || []);
      } catch (err) {
        setError("Failed to load machines.");
      } finally {
        setLoading(false);
      }
    };
    if (groupId) fetchMachines();
  }, [groupId]);

  if (loading)
    return (
      <Stack
        spacing={2}
        sx={{
          height: "80vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress sx={{ color: "#424242" }} />
      </Stack>
    );
  if (error)
    return (
      <Stack
        spacing={2}
        sx={{
          height: "80vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography color="error">{error}</Typography>
        <Box
          sx={{
            width: "100%",
            maxWidth: "150px",
            height: "40px",
            backgroundColor: "#424242",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "&:hover": {
              backgroundColor: "#686868",
            },
            flexShrink: 0,
            margin: "10px",
          }}
        >
          <Button
            sx={{
              color: "#ffffff",
              textTransform: "none",
            }}
            onClick={() => window.location.reload()}
          >
            Retry
          </Button>
        </Box>
      </Stack>
    );

  if (!machines.length)
    return (
      <>
        <Stack
          direction="row"
          spacing={2}
          sx={{
            justifyContent: "flex-start",
            alignItems: "center",
          }}
          m={3}
          onClick={() => navigate(-1)}
        >
          <ArrowBackIcon />
          <Typography color="text.primary" marginX={5}>
            <strong>Lister</strong>
          </Typography>
        </Stack>
        <Stack
          spacing={2}
          sx={{
            height: "80vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography>Ingen maskiner fundet.</Typography>
        </Stack>
      </>
    );

  return (
    <>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          justifyContent: "flex-start",
          alignItems: "center",
        }}
        m={3}
        onClick={() => navigate(-1)}
      >
        <ArrowBackIcon />
        <Typography color="text.primary" marginX={5}>
          <strong>Lister</strong>
        </Typography>
      </Stack>
      <Stack direction="column" spacing={2} marginX={2} marginBottom={4}>
        {machines.map((item) => (
          <Stack
            direction="row"
            spacing={2}
            marginX={5}
            marginY={2}
            key={item.id}
            justifyContent="space-between"
            onClick={() => navigate(`/machine/${item.id}`)}
            sx={{
              alignItems: "center",
            }}
          >
            <DemoPaper>
              <Stack
                direction={"row"}
                sx={{
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Stack spacing={1}>
                  <Typography variant="h6" color={"#424242"}>
                    {item.machine.brand_name} {item.machine.name} /{" "}
                    {item.internal_name}
                  </Typography>
                </Stack>
                <IconButton
                  sx={{
                    transform: "rotate(-90deg)",
                  }}
                >
                  <ExpandCircleDownOutlinedIcon />
                </IconButton>
              </Stack>
            </DemoPaper>
          </Stack>
        ))}
      </Stack>
    </>
  );
}

export default MachinesInGroups;
